import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(["", $props.textColor === '' ? 'text-secondary-500 dark:text-secondaryDark-white' : $props.textColor])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}